import { inViewFadeUp } from '@helpers/animate';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { contentStyles, h3, micro } from '@helpers/typography';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import SimpleImage from '@stories/Components/SimpleImage/SimpleImage';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  margin: var(--sectionSpacing) 0;
`;
const Inner = styled.div `
  ${baseGrid};

  [data-layout='1'] & {
    row-gap: 32px;
  }

  [data-layout='2'] & {
    @media ${until(Device.TabletLarge)} {
      row-gap: 32px;
    }
  }

  [data-layout='3'] & {
    @media ${until(Device.TabletLarge)} {
      row-gap: 32px;
    }
  }

  [data-layout='4'] & {
    @media ${until(Device.TabletLarge)} {
      row-gap: 32px;
    }
  }

  [data-layout='5'] & {
    row-gap: 32px;
  }

  [data-layout='6'] & {
    row-gap: 32px;
  }

  [data-layout='7'] & {
    row-gap: 32px;
  }

  [data-image-padding='true'] & {
    padding-bottom: 125px;

    @media ${until(Device.TabletLarge)} {
      padding-bottom: 0;
    }
  }
`;
const Title = styled.h2 `
  [data-layout='1'] & {
    ${h3};
    margin-bottom: 0;

    @media ${until(Device.TabletLarge)} {
      grid-column: 1 / span 12;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: 1 / span 6;
      max-width: 555px;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: 2 / span 5;
    }
  }

  [data-layout='2'] & {
    ${h3};

    @media ${until(Device.TabletLarge)} {
      grid-column: 1 / span 12;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: 1 / span 12;
      margin-bottom: ${fluid(48, 72)};
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: 2 / span 10;
    }
  }

  [data-layout='3'] & {
    ${h3};

    @media ${until(Device.TabletLarge)} {
      grid-column: 1 / span 12;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: 1 / span 6;
      max-width: 540px;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: 2 / span 5;
    }
  }

  [data-layout='4'] & {
    ${h3};

    @media ${until(Device.TabletLarge)} {
      grid-column: 1 / span 12;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: 1 / span 12;
      margin-bottom: ${fluid(48, 72)};
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: 2 / span 10;
    }
  }

  [data-layout='5'] & {
    ${h3};

    grid-column: 1 / span 12;
    margin-bottom: 0;

    @media ${from(Device.TabletLarge)} {
      grid-column: 1 / span 6;
      grid-row: 1;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: 2 / span 10;
    }
  }

  [data-layout='6'] & {
    ${h3};

    grid-column: 1 / span 12;
    margin-bottom: 0;

    @media ${from(Device.TabletLarge)} {
      grid-column: -7 / span 6;
      grid-row: 1;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: 2 / span 10;
    }
  }

  [data-layout='7'] & {
    ${h3};

    grid-column: 1 / span 12;
    grid-row: 1;
    margin-bottom: 0;

    @media ${from(Device.DesktopSmall)} {
      grid-column: 2 / span 10;
    }
  }

  ${inViewFadeUp({ delay: 0, duration: 0.3 })};
`;
const ContentWrapper = styled.div `
  [data-layout='1'] & {
    @media ${until(Device.TabletLarge)} {
      grid-column: 1 / span 12;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: 7 / span 6;
      max-width: 635px;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: 7 / span 5;
    }
  }

  [data-layout='2'] & {
    @media ${until(Device.TabletLarge)} {
      grid-column: 1 / span 12;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: 1 / span 5;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: 2 / span 4;
    }
  }

  [data-layout='3'] & {
    @media ${until(Device.TabletLarge)} {
      grid-column: 1 / span 12;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: 1 / span 6;
      max-width: 540px;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: 2 / span 5;
    }
  }

  [data-layout='4'] & {
    @media ${until(Device.TabletLarge)} {
      grid-column: 1 / span 12;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: -7 / span 6;
      max-width: 492px;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: -7 / span 5;
    }
  }

  [data-layout='5'] & {
    grid-column: 1 / span 12;

    @media ${from(Device.TabletLarge)} {
      grid-column: 1 / span 6;
      grid-row: 2 / span 2;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: 2 / span 5;
    }
  }

  [data-layout='6'] & {
    grid-column: 1 / span 12;

    @media ${from(Device.TabletLarge)} {
      grid-column: -7 / span 6;
      grid-row: 2 / span 2;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: -7 / span 5;
    }
  }

  [data-layout='7'] & {
    grid-column: 1 / span 12;
    grid-row: 2;
    margin-bottom: 0;

    @media ${from(Device.DesktopSmall)} {
      grid-column: 2 / span 10;
    }
  }

  ${inViewFadeUp({ delay: 0.15, duration: 0.3 })};
`;
const Content = styled.div `
  ${contentStyles};
`;
const CtaWrapper = styled.div `
  margin-top: 24px;

  @media ${from(Device.TabletLarge)} {
    margin-top: 48px;
  }
`;
const Image1 = styled.figure `
  [data-layout='1'] & {
    @media ${until(Device.TabletLarge)} {
      grid-column: 1 / span 7;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: 1 / span 5;
      margin-bottom: 138px;
      max-width: 492px;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: 2 / span 4;
    }
  }

  [data-layout='2'] & {
    @media ${until(Device.TabletLarge)} {
      grid-column: -8 / span 7;
      grid-row: 4;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: -7 / span 6;
      grid-row: span 2;
      margin-left: auto;
      max-width: 556px;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: -7 / span 5;
    }
  }

  [data-layout='3'] & {
    @media ${until(Device.TabletLarge)} {
      grid-column: 1 / span 12;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: -6 / span 5;
      grid-row: 1 / span 2;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: -7 / span 5;
    }
  }

  [data-layout='4'] & {
    @media ${until(Device.TabletLarge)} {
      grid-column: 1 / span 12;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: 1 / span 5;
      grid-row: 2;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: 2 / span 4;
    }
  }

  [data-layout='5'] & {
    grid-column: 1 / span 12;

    @media ${from(Device.TabletLarge)} {
      grid-column: -7 / span 6;
      grid-row: 2;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: -7 / span 5;
    }
  }

  [data-layout='6'] & {
    grid-column: 1 / span 12;

    @media ${from(Device.TabletLarge)} {
      grid-column: 1 / span 6;
      grid-row: 2;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: 2 / span 5;
    }
  }

  [data-layout='7'] & {
    grid-column: 1 / span 12;

    @media ${from(Device.TabletLarge)} {
      grid-column: 1 / span 6;
      grid-row: 3;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: 2 / span 5;
    }
  }

  ${inViewFadeUp({ delay: 0.3, duration: 0.3 })};
`;
const Image2 = styled.figure `
  [data-layout='1'] & {
    @media ${until(Device.TabletLarge)} {
      grid-column: -8 / span 7;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: 7 / span 6;
      margin-top: auto;
      margin-left: auto;
      max-width: 556px;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: 7 / span 5;
    }
  }

  [data-layout='2'] & {
    @media ${until(Device.TabletLarge)} {
      grid-column: 1 / span 7;
      grid-row: 3;
    }

    @media ${from(Device.TabletLarge)} {
      align-self: flex-end;
      grid-column: 1 / span 5;
      margin-bottom: -125px;
      max-width: 492px;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: 2 / span 4;
    }
  }

  [data-layout='5'] & {
    grid-column: 1 / span 12;

    @media ${from(Device.TabletLarge)} {
      grid-column: -7 / span 6;
      grid-row: 3;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: -7 / span 5;
    }
  }

  [data-layout='6'] & {
    grid-column: 1 / span 12;

    @media ${from(Device.TabletLarge)} {
      grid-column: 1 / span 6;
      grid-row: 3;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: 2 / span 5;
    }
  }

  [data-layout='7'] & {
    grid-column: 1 / span 12;

    @media ${from(Device.TabletLarge)} {
      grid-column: 7 / span 6;
      grid-row: 3;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: 7 / span 5;
    }
  }

  ${inViewFadeUp({ delay: 0.4, duration: 0.3 })};
`;
const Image = styled(SimpleImage) `
  display: block;
`;
const CaptionWrapper = styled.figcaption `
  margin-top: 8px;
  text-align: center;
`;
const Caption1 = styled.span `
  ${micro};

  display: block;
  ${fonts.helvetica.regular}
  margin: 0;
`;
const Caption2 = styled.span `
  ${micro};

  display: block;
  ${fonts.helvetica.bold};
  margin: 0;
`;
const ContentIntroSectionStyles = {
    Caption1,
    Caption2,
    CaptionWrapper,
    Container,
    Content,
    ContentWrapper,
    CtaWrapper,
    Image,
    Image1,
    Image2,
    Inner,
    Title,
};
export default ContentIntroSectionStyles;
